const waitForMyElement = (element, callback) => {
    const maxWaitTime = 7000;
    const interval = 90;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
      const selector = document.querySelector(element);
      if (selector) {
        callback();
        clearInterval(waitingInterval);
      } else {
        elapsedTime += interval;
        if (elapsedTime >= maxWaitTime) {
          clearInterval(waitingInterval);
        }
      }
    }, interval);
  };

 

document.addEventListener('DOMContentLoaded', function () {
  const reviews = document.querySelectorAll('.js-featured-review');
  const atcBtn = document.querySelector('.product__accordion accordion');
  const featuredReviews = document.querySelector('.PS-015-review-cont');
  if (reviews.length > 0) {
    const randomIndex = Math.floor(Math.random() * reviews.length);
    reviews[randomIndex].style.display = 'flex';
  }

//  waitForMyElement(".product__accordion accordion", () => {
//   featuredReviews.style.display = 'block';
//     atcBtn.insertAdjacentElement('beforebegin', featuredReviews)
//   });

//   waitForMyElement(".product__info-wrapper", () => {
//     const productInfo = document.querySelector(".product__info-wrapper");
//     const productForm = productInfo.querySelector(".product-form");

//     if (!document.querySelector(".PS-015-review-cont")) {
//         productForm.parentElement.after(featuredReviews);
//     }
// });
});

